export const STAKE_INPUT_REGEX = /^(\d*)(\.\d{0,2})?/;

export const clampValue = (value, min, max) =>
  Math.min(Math.max(value, min), max);

export const parseStakeInput = (value) => {
  const decimalMatch = value.match(STAKE_INPUT_REGEX);
  if (!decimalMatch) {
    return { sanitizedInput: '', numericValue: null };
  }

  const integerPart = decimalMatch[1] || '';
  const decimalPart = decimalMatch[2] || '';
  const hasTrailingDot = value.includes('.') && !decimalPart;
  const sanitizedInput = integerPart + (hasTrailingDot ? '.' : decimalPart);

  if (sanitizedInput === '' || sanitizedInput.endsWith('.')) {
    return { sanitizedInput, numericValue: null };
  }

  const numericValue = parseFloat(sanitizedInput);
  return {
    sanitizedInput,
    numericValue: Number.isNaN(numericValue) ? null : numericValue,
  };
};

export const calculateInitialStake = (proposedStake, config) => {
  const { minStake, maxStake } = config;
  if (maxStake >= minStake) {
    return clampValue(proposedStake, minStake, maxStake);
  }
  return Math.max(0, Math.min(proposedStake, maxStake));
};

export const formatStakeDisplay = (value) => {
  const parts = value.toFixed(2).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

export const calculateSafeStake = (inputValue, config) => {
  const { minStake, maxStake, defaultStake } = config;
  const numValue = parseFloat(inputValue);

  if (Number.isNaN(numValue) || inputValue === '') {
    if (maxStake >= minStake) {
      return clampValue(defaultStake, minStake, maxStake);
    }
    return Math.min(defaultStake, maxStake);
  }

  if (maxStake >= minStake) {
    return clampValue(numValue, minStake, maxStake);
  }
  return Math.min(numValue, maxStake);
};
